import {IHttpResponse} from './Service';
import {AuthenticatedService} from './AuthenticatedService';
import {Page} from '../Models';
import {Author} from './AuthorService';

export interface User {
  id: number;
  username: string;
  author?: Author;
}

export class UserService extends AuthenticatedService {
  public list = async (page: number = 1): Promise<IHttpResponse<Page<User>>> => {
    const users = await this.getAuth<Page<User>>(
      `users?page=${page}`,
    );

    return users;
  }

  public byId = async (id: number): Promise<IHttpResponse<User>> => {
    const user = await this.getAuth<User>(
      `users/${id}`,
    );

    return user;
  }

  public byAuthor = async (author: number): Promise<IHttpResponse<User>> => {
    const user = await this.getAuth<User>(
      `users/author/${author}`,
    );

    return user;
  }

  public byUsername = async (username: string): Promise<IHttpResponse<User>> => {
    const user = await this.getAuth<User>(
      `users/username/${username}`,
    );

    return user;
  }

  public create = async (user: User): Promise<IHttpResponse<User>> => {
    const newUser = await this.postAuth<User>(
      'users', user,
    );

    return newUser;
  }

  public update = async (user: User): Promise<IHttpResponse<User>> => {
    const newUser = await this.postAuth<User>(
      `users/${user.id}`, user,
    );

    return newUser;
  }

  public remove = async (id: number): Promise<IHttpResponse<User>> => {
    const newUser = await this.deleteAuth<User>(
      `users/${id}`,
    );

    return newUser;
  }
}
